/*
 * Laurent — kleine Verhaltensweisen, die sich nicht in CSS ausdruecken lassen.
 *
 * 1. Positionsanzeige unter den Wisch-Reihen (Spec Abschnitt 3).
 * 2. Fusszeilen-Linkspalten: mobil zugeklappt, auf Desktop offen.
 *
 * Die Punkte sind reine Anzeige: nicht anklickbar, nicht fokussierbar, fuer
 * Screenreader ausgeblendet. Wer die Reihe bedienen will, wischt sie.
 *
 * Erzeugt werden sie hier statt im Liquid, weil eine der drei Reihen aus
 * Crafts Multicolumn-Sektion kommt — deren Markup fuer diesen einen Fall
 * anzufassen, haette die Sektion an allen anderen Einsatzorten mitveraendert.
 *
 * Faellt das Skript aus, fehlt nur die Anzeige. Die Reihen bleiben bedienbar.
 */
(function () {
  'use strict';

  var ROWS = [
    '[id$="__vertrauensleiste"] .multicolumn-list',
    '.lh-auswahl__grid',
    '.lh-materialien__grid',
  ];

  var mobile = window.matchMedia('(max-width: 749px)');

  function buildDots(row) {
    if (row.dataset.lhDots === 'on') return;

    var cards = Array.prototype.filter.call(row.children, function (el) {
      return el.nodeType === 1;
    });
    if (cards.length < 2) return;

    var dots = document.createElement('div');
    dots.className = 'lh-dots';
    dots.setAttribute('aria-hidden', 'true');

    cards.forEach(function () {
      dots.appendChild(document.createElement('span')).className = 'lh-dots__dot';
    });

    row.insertAdjacentElement('afterend', dots);
    row.dataset.lhDots = 'on';

    var ticking = false;

    function update() {
      ticking = false;
      var mid = row.scrollLeft + row.clientWidth / 2;
      var active = 0;
      var best = Infinity;

      cards.forEach(function (card, i) {
        var centre = card.offsetLeft + card.offsetWidth / 2;
        var gap = Math.abs(centre - mid);
        if (gap < best) {
          best = gap;
          active = i;
        }
      });

      Array.prototype.forEach.call(dots.children, function (dot, i) {
        dot.classList.toggle('lh-dots__dot--active', i === active);
      });
    }

    row.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    update();
    row._lhDotsUpdate = update;
  }

  function removeDots(row) {
    if (row.dataset.lhDots !== 'on') return;
    var dots = row.nextElementSibling;
    if (dots && dots.classList.contains('lh-dots')) dots.remove();
    delete row.dataset.lhDots;
  }

  function sync() {
    ROWS.forEach(function (selector) {
      Array.prototype.forEach.call(document.querySelectorAll(selector), function (row) {
        if (mobile.matches) {
          buildDots(row);
          if (row._lhDotsUpdate) row._lhDotsUpdate();
        } else {
          removeDots(row);
        }
      });
    });
  }

  /*
   * Fusszeilen-Aufklapper.
   *
   * Das Markup liefert <details open> aus. Unter 750px wird zugeklappt, ab
   * 750px wieder geoeffnet. Diese Richtung ist Absicht: faellt das Skript
   * aus, sind die Spalten offen und alle Links erreichbar — der umgekehrte
   * Weg haette sie im Fehlerfall versteckt.
   */
  function syncFooter() {
    var panels = document.querySelectorAll('.lh-footer-accordion');
    Array.prototype.forEach.call(panels, function (panel) {
      if (mobile.matches) {
        // Nur beim Wechsel zumachen, nicht bei jedem Aufruf — sonst faellt
        // eine vom Besucher geoeffnete Spalte wieder zu.
        if (panel.dataset.lhMobile !== 'on') {
          panel.open = false;
          panel.dataset.lhMobile = 'on';
        }
      } else {
        panel.open = true;
        delete panel.dataset.lhMobile;
      }
    });
  }

  function syncAll() {
    sync();
    syncFooter();
  }

  document.addEventListener('DOMContentLoaded', syncAll);
  if (document.readyState !== 'loading') syncAll();

  mobile.addEventListener('change', syncAll);

  // Im Theme-Editor werden Sektionen neu geladen, ohne dass die Seite neu baut.
  document.addEventListener('shopify:section:load', syncAll);
  document.addEventListener('shopify:section:unload', syncAll);
})();
